import { render, staticRenderFns } from "./china_new.vue?vue&type=template&id=60dbf16d&"
import script from "./china_new.vue?vue&type=script&lang=js&"
export * from "./china_new.vue?vue&type=script&lang=js&"
import style0 from "./china_new.vue?vue&type=style&index=0&id=60dbf16d&prod&lang=less&less=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports